import * as React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useWindowDimensions } from 'react-native';
import ModalScreen from '../screens/ModalScreen';
import NotFoundScreen from '../screens/NotFoundScreen';
import { RootStackParamList } from '../types/Navigation';
import LinkingConfiguration from './LinkingConfiguration';
import DrawerNavigator from './DrawerNavigator';
import TabNavigator from './TabNavigator';
import useThemeStyles from '../hooks/useThemeStyles';
import LoginScreen from '../screens/LoginScreen';
import SignUpScreen from '../screens/SignUpScreen';


export default function Navigation() {

  return (
    <NavigationContainer
      linking={LinkingConfiguration}
      theme={useThemeStyles()}>
      <RootNavigator />
    </NavigationContainer>
  );
}

const Stack = createNativeStackNavigator<RootStackParamList>();

export function RootNavigator() {
 
  const dimensions = useWindowDimensions();

  const nav = dimensions.width > 425 ? DrawerNavigator : TabNavigator

  return (
    <Stack.Navigator>
      <Stack.Screen name="Gabba" component={nav} options={{ headerShown: false }} />
      <Stack.Screen name="NotFound" component={NotFoundScreen} options={{ title: 'Oops!' }} />
      <Stack.Screen name="Modal" component={ModalScreen} />
      <Stack.Screen name="Login" options={{ headerShown: false }} component={LoginScreen}/>
      <Stack.Screen name="SignUp" options={{ headerShown: false }} component={SignUpScreen}/>
    </Stack.Navigator>
  );
}
